module.exports = __webpack_public_path__ + "img/website.adf3379a.svg";